/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Creations_HeadingInputs */

const id_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik kreasi Epic Games Store`)
};

const ms_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik ciptaan Epic Games Store`)
};

const da_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store oprettelsesstatistik`)
};

const de_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store Erstellungsstatistiken`)
};

const en_us2_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store creation stats`)
};

const es_es2_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de creaciones de la Epic Games Store`)
};

const es_mx2_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de creaciones de la Epic Games Store`)
};

const fil_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika ng creation ng Epic Games Store`)
};

const fr_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques de créations de l'Epic Games Store`)
};

const it_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche creazioni Epic Games Store`)
};

const hu_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store létrehozási statisztikák`)
};

const nl_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store creatiestatistieken`)
};

const no_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store opprettelsesstatistikk`)
};

const pl_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki tworzenia w Epic Games Store`)
};

const pt_br2_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de criação de Epic Games Store`)
};

const pt_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de criações da Epic Games Store`)
};

const ro_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici creații Epic Games Store`)
};

const fi_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Storen luontitilastot`)
};

const sv_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store skapelsestatistik`)
};

const vi_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê sáng tạo Epic Games Store`)
};

const tr_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store oluşturma istatistikleri`)
};

const cs_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky vytvoření Epic Games Store`)
};

const bg_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика на създаванията в Epic Games Store`)
};

const ru_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релизов Epic Games Store`)
};

const uk_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика створень Epic Games Store`)
};

const ar_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات إنشاءات Epic Games Store`)
};

const hi_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store निर्माण आँकड़े`)
};

const th_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติการสร้าง Epic Games Store`)
};

const ja_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 作成統計`)
};

const zh_cn2_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城创作统计`)
};

const zh_hant1_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城創作統計`)
};

const ko_stats_creations_heading = /** @type {(inputs: Stats_Creations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 생성 통계`)
};

/**
* | output |
* | --- |
* | "Epic Games Store creation stats" |
*
* @param {Stats_Creations_HeadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_creations_heading = /** @type {((inputs?: Stats_Creations_HeadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Creations_HeadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_creations_heading(inputs)
	if (locale === "ms") return ms_stats_creations_heading(inputs)
	if (locale === "da") return da_stats_creations_heading(inputs)
	if (locale === "de") return de_stats_creations_heading(inputs)
	if (locale === "en-US") return en_us2_stats_creations_heading(inputs)
	if (locale === "es-ES") return es_es2_stats_creations_heading(inputs)
	if (locale === "es-MX") return es_mx2_stats_creations_heading(inputs)
	if (locale === "fil") return fil_stats_creations_heading(inputs)
	if (locale === "fr") return fr_stats_creations_heading(inputs)
	if (locale === "it") return it_stats_creations_heading(inputs)
	if (locale === "hu") return hu_stats_creations_heading(inputs)
	if (locale === "nl") return nl_stats_creations_heading(inputs)
	if (locale === "no") return no_stats_creations_heading(inputs)
	if (locale === "pl") return pl_stats_creations_heading(inputs)
	if (locale === "pt-BR") return pt_br2_stats_creations_heading(inputs)
	if (locale === "pt") return pt_stats_creations_heading(inputs)
	if (locale === "ro") return ro_stats_creations_heading(inputs)
	if (locale === "fi") return fi_stats_creations_heading(inputs)
	if (locale === "sv") return sv_stats_creations_heading(inputs)
	if (locale === "vi") return vi_stats_creations_heading(inputs)
	if (locale === "tr") return tr_stats_creations_heading(inputs)
	if (locale === "cs") return cs_stats_creations_heading(inputs)
	if (locale === "bg") return bg_stats_creations_heading(inputs)
	if (locale === "ru") return ru_stats_creations_heading(inputs)
	if (locale === "uk") return uk_stats_creations_heading(inputs)
	if (locale === "ar") return ar_stats_creations_heading(inputs)
	if (locale === "hi") return hi_stats_creations_heading(inputs)
	if (locale === "th") return th_stats_creations_heading(inputs)
	if (locale === "ja") return ja_stats_creations_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_creations_heading(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_creations_heading(inputs)
	return ko_stats_creations_heading(inputs)
});
export { stats_creations_heading as "stats.creations.heading" }